import { CustomerMicroServiceWriterApi, CustomerProfileWriterApi, DenDeploymentWriterApi, InfraManagementWriterApi, PreLoginWriterApi, SharedMicroServiceWriterApi } from './shared/auto-generated-devumconsole/services/writer-apis';
import { MiniCrmWriterApi, SignUpRequestWriterApi, RegionEKSClusterWriterApi, SupportedRegionWriterApi } from 'src/app/shared/auto-generated-devumconsole/services/writer-apis';
import { SupportedRegionReaderApi, RegionEKSClusterReaderApi, SubscriptionReaderApi, InfraManagementReaderApi, CustomerProfileReaderApi, AgentDeploymentReaderApi, MiniCrmReaderApi } from 'src/app/shared/auto-generated-devumconsole/services/reader-apis';
import { ConfigService } from './../../libs/dc-core/providers/config-service';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AmplifyUIAngularModule } from '@aws-amplify/ui-angular';
import { APIInterceptor } from 'libs/dc-core/interceptors/http.interceptor';
import { NgMaterialModule } from 'libs/dc-core/modules/ng-material.module';
import { ToastComponent } from 'libs/dc-core/ng-core/components/toast/toast.component';
import { DialogService } from 'libs/dc-core/ng-core/service/mat-dialog-provider/mat-dialog-provider';
import { ModalService } from 'libs/dc-core/ng-core/service/modal-service/modalservice';
import { ToastService } from 'libs/dc-core/ng-core/service/toast/toast-service';
import { DialogProvider } from 'libs/dc-core/providers/abstract/dialog-provider';
import { ForeignKeyEntityResolverProvider } from 'libs/dc-core/providers/abstract/foreign-key-entity-Provider';
import { HttpClientProvider } from 'libs/dc-core/providers/abstract/http-client-provider';
import { LocalStorageProvider } from 'libs/dc-core/providers/abstract/indexdb-manager-service-provider';
import { ToastServiceProvider } from 'libs/dc-core/providers/abstract/toast-service-provider';
import { AngularHttpProvider } from 'libs/dc-core/providers/angular-client-provider';
import { DependencyService } from 'libs/dc-core/providers/dependency.service';
import { GlobalWebSocketService } from 'libs/dc-core/providers/global-web-socket/global-web-socket.service';
import { WebSocketService } from 'libs/dc-core/providers/global-web-socket/web-socket/web-socket.service';
import { IndexDBManagerService } from 'libs/dc-core/providers/index-db-manager.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// import { FooterComponent } from './components/footer/footer.component';
// import { HeaderComponent } from './components/header/header.component';
// import { NavigationComponent } from './components/navigation/navigation.component';
import { StripeModule } from "stripe-angular";
import { NgxStripeModule } from 'ngx-stripe';
import { LoaderService } from 'libs/dc-core/providers/loader/loader.service';
import { LoaderServiceProvider } from 'libs/dc-core/providers/abstract/loader-service-provider';
import { PlanReaderApi } from './shared/auto-generated-devumconsole/services/reader-apis';
import { PageRefreshService } from 'libs/dc-core/providers/page-refresh/page-refresh.service';
import { PaymentMethodEnumApi, PaymentFrequencyEnumApi, LeadSourceEnumApi, DeploymentTypeApi, CurrencyTypeEnumApi, EnvironmentTypeApi } from './shared/auto-generated-devumconsole/models/enum-models';
import { PipesModule } from './components/pipes/pipes.module';
import { AuthGuard } from './auth.guard';


@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    ToastComponent,
    // FooterComponent,
    // NavigationComponent,
    // HeaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    OverlayModule,
    AmplifyUIAngularModule,
    NgMaterialModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxSliderModule,
    PipesModule
  ],
  providers: [
    HttpClient,
    ModalService,
    WebSocketService,
    GlobalWebSocketService,
    ConfigService,
    PageRefreshService,
    { provide: HttpClientProvider, useClass: AngularHttpProvider },
    { provide: LocalStorageProvider, useClass: IndexDBManagerService },
    { provide: LoaderServiceProvider, useClass: LoaderService },
    { provide: ForeignKeyEntityResolverProvider, useClass: DependencyService },
    { provide: ToastServiceProvider, useClass: ToastService },
    { provide: DialogProvider, useClass: DialogService },
    { provide: HTTP_INTERCEPTORS, useClass: APIInterceptor, multi: true },
    PaymentMethodEnumApi,
    PlanReaderApi,
    PaymentFrequencyEnumApi,
    LeadSourceEnumApi,
    DeploymentTypeApi,
    CurrencyTypeEnumApi,
    SupportedRegionReaderApi,
    MiniCrmWriterApi,
    SignUpRequestWriterApi,
    RegionEKSClusterReaderApi,
    RegionEKSClusterWriterApi,
    SupportedRegionWriterApi,
    SubscriptionReaderApi,
    InfraManagementWriterApi,
    EnvironmentTypeApi,
    InfraManagementReaderApi,
    PreLoginWriterApi,
    CustomerProfileReaderApi,
    CustomerProfileWriterApi,
    MiniCrmReaderApi,
    AuthGuard,
    SharedMicroServiceWriterApi,
    AgentDeploymentReaderApi,
    DenDeploymentWriterApi,
    CustomerMicroServiceWriterApi],
  bootstrap: [AppComponent]
})
export class AppModule { }


